import { Link } from "react-router-dom";

interface HeroBannerProps {
  hotArticles: Array<{
    id: string;
    title: string;
    coverImage: string;
    categorySlug: string;
    excerpt: string;
  }>;
}

const categoryLabelMap: Record<string, string> = {
  "hot-tracking": "热点追踪",
  "deep-dive": "深度揭秘",
  "entertainment": "娱乐八卦",
  "society": "社会万象",
  "tech": "科技数码",
  "finance": "财经内幕",
};

export default function HeroBanner({ hotArticles }: HeroBannerProps) {
  const mainArticle = hotArticles[0];
  const sideArticles = hotArticles.slice(1, 4);

  return (
    <section className="relative pt-20 pb-10 md:pt-24 md:pb-14">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <Link
            to={`/article/${mainArticle.id}`}
            className="lg:col-span-2 group relative rounded-2xl overflow-hidden cursor-pointer h-[320px] md:h-[420px]"
          >
            <img
              src={mainArticle.coverImage}
              alt={mainArticle.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className="inline-block px-3 py-1 text-xs bg-accent-500 text-background-50 rounded-full mb-3">
                {categoryLabelMap[mainArticle.categorySlug] || mainArticle.categorySlug}
              </span>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white leading-tight line-clamp-2">
                {mainArticle.title}
              </h2>
              <p className="text-sm md:text-base text-white/80 mt-2 line-clamp-2 hidden sm:block">
                {mainArticle.excerpt}
              </p>
            </div>
          </Link>

          <div className="flex flex-col gap-4 md:gap-5">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group relative rounded-xl overflow-hidden cursor-pointer h-[100px] md:h-[130px]"
              >
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2 py-0.5 text-[10px] bg-primary-500 text-background-50 rounded-full mb-1.5">
                    {categoryLabelMap[article.categorySlug] || article.categorySlug}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-white line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}